import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ScreenSizeService, ViewMode } from '../../../services/screen-size';
import { BildungsBereich } from '../../../services/state/bildungsbereich.service';

@Component({
  selector: 'now-wbsuche-lib-themenfeld-bildungsbereich-change',
  imports: [NgClass],
  templateUrl: `themenfeld-bildungsbereich-change.component.html`,
  styleUrl: './themenfeld-bildungsbereich-change.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThemenfeldBildungsbereichChangeComponent {
  private readonly screenSizeService = inject(ScreenSizeService);

  @Output() selectionEmitter = new EventEmitter<BildungsBereich>();

  public Bildungsbereich = BildungsBereich;

  public selectedBildungsbereich: BildungsBereich | null = null;

  selectBildungsbereich(bildungsbereich: BildungsBereich) {
    this.selectedBildungsbereich = bildungsbereich;
  }

  emitSelection() {
    if (this.selectedBildungsbereich) {
      this.selectionEmitter.emit(this.selectedBildungsbereich);
    }
  }

  isMobile = toSignal(this.screenSizeService.rangeTo$(ViewMode.PHONE));
}
